import { useQuery } from '@tanstack/react-query'
import { ICheckupList } from 'models'
import { ICowsList } from 'models/ICattlesData'
import { useState } from 'react'
import CattlesApiService from 'services/cattlesApiServices'
import { defaultCheckupInfo } from '../../components/cattles/checkupPage/processes/checkup'

interface CowInfoHookProps {
	tag_id: string
}

export const useGetCowInfoByTagId = ({ tag_id }: CowInfoHookProps) => {
	const {
		data: cowInfo,
		isLoading,
		isError,
		error,
	} = useQuery<ICowsList>({
		queryKey: ['cowInfo', tag_id],
		queryFn: () =>
			CattlesApiService.getCowInfoByTagId(tag_id).then(res => res.data),
		enabled: !!tag_id,
		retry: 1,
		refetchOnWindowFocus: false,
	})

	const [checkupInfo, setCheckupInfo] =
		useState<ICheckupList>(defaultCheckupInfo)

	return {
		cowInfo,
		isLoading,
		isError,
		error,
		checkupInfo,
		setCheckupInfo,
	}
}
